<template>
  <div id="app">
    <Header routeValue="5" ref="header"></Header>
    <content class="integrations_content">
      <!-- 顶部 Banner -->
      <div class="special_banner">
        <div class="left_box">
          <div class="small_title">Tech that empowers you to</div>
          <h1>Sell Globally</h1>
          <div class="text">
            Unlock seamless integrations that let you sell across multiple
            <br>
            channels with ease.
          </div>
          <div class="btn_wrap">
            <a :href="href" class="link btn-standard" target="_blank">Get Started</a>
          </div>
        </div>
      </div>

      <!-- Printbelle Integrations 模块 -->
      <div class="integrations-section">
        <h2 class="section-title">Printbelle Integrations</h2>
        <div class="grid-row">
          <div class="integration-card" v-for="item in printbelleItems" :key="item.name">
            <div class="card-box" :class="item.colorClass">
              <div class="card-header">
                <img :src="item.icon" alt="" class="card-icon">
                <span class="card-name">{{ item.name }}</span>
              </div>
              <div class="card-key">Type: <span class="card-value">{{ item.type }}</span></div>
              <div class="card-key">Setup time: <span class="card-value">{{ item.setupTime }}</span></div>
              <div class="card-key">Best for: <span class="card-value">{{ item.bestFor }}</span></div>
            </div>
            <a :href="item.link" class="card-link" target="_blank">
              <span class="link-text">{{ item.linkText.split(' →')[0] }}</span>
              <span class="link-arrow">→</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Order Desk Integrations 模块 -->
      <div class="integrations-section">
        <h2 class="section-title">Order Desk Integrations</h2>
        <div class="grid-container">
          <div class="integration-card" style="background: #F7F8FB;padding-bottom: 25px;  border: 1px solid transparent"
               v-for="item in orderDeskItems" :key="item.name">
            <div class="card-box" style="padding: 6px 33px;">
              <div class="card-header">
                <img :src="item.icon" alt="" class="card-icon">
                <div class="card-name">{{ item.name }}</div>
              </div>
              <div class="card-key">Type: <span class="card-value">{{ item.type }}</span></div>
              <div class="card-key">Setup time: <span class="card-value">{{ item.setupTime }}</span></div>
              <div class="card-key">Best for: <span class="card-value">{{ item.bestFor }}</span></div>
            </div>
            <a :href="href" class="card-link" target="_blank">
              <span class="link-text">{{ item.linkText.split(' →')[0] }}</span>
              <span class="link-arrow">→</span>
            </a>
          </div>
        </div>
      </div>

      <div class="bottom-cta">
        <p class="cta-subtitle">Perfect for creatives, entrepreneurs and businesses of all sizes.</p>
        <h3 class="cta-title">Boost your POD business using our powerful integrations.</h3>
        <a :href="href" class="cta-btn" target="_blank">Get Started</a>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'Integrations',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      href: process.env.VUE_APP_MERCHANT + 'user/register',
      printbelleItems: [
        {
          name: 'Customily',
          type: 'Platform',
          setupTime: 'Very fast',
          bestFor: 'Everyone',
          linkText: 'Learn More →',
          colorClass: 'card-gray',
          link: 'https://app.customily.com/stamp/printbelle',
          icon: require('../assets/icon/customily.png')
        },
        {
          name: 'Shopify',
          type: 'Platform',
          setupTime: 'Very fast',
          bestFor: 'Small Business',
          linkText: 'Learn More →',
          colorClass: 'card-green',
          link: 'https://apps.shopify.com/printbelle-print-on-demand',
          icon: require('../assets/icon/shopify.png')
        },
        {
          name: 'Printbelle API',
          type: 'API',
          setupTime: 'Moderate',
          bestFor: 'Developers, large retailers',
          linkText: 'Learn More →',
          colorClass: 'card-blue',
          link: 'https://documenter.getpostman.com/view/25923095/2s93RL1vvB',
          icon: require('../assets/icon/printbelle-api.png')
        },
        {
          name: 'Teeinblue',
          type: 'Platform',
          setupTime: 'Very fast',
          bestFor: 'Everyone',
          linkText: 'Learn More →',
          colorClass: 'card-lightblue',
          link: 'https://teeinblue.com/pages/printbelle',
          icon: require('../assets/icon/teeinblue.png')
        },
        {
          name: 'Order Desk',
          type: 'Platform',
          setupTime: 'Moderate',
          bestFor: 'Small Business',
          linkText: 'Learn More →',
          colorClass: 'card-pink',
          link: 'https://www.orderdesk.com/integrations/printbelle',
          icon: require('../assets/icon/order-desk.png')
        },
        {
          name: 'DodgePrint',
          type: 'Platform',
          setupTime: 'Very fast',
          bestFor: 'Everyone',
          linkText: 'Learn More →',
          colorClass: 'card-pink',
          link: 'https://dodgeprint.com/vi/integrations/printbelle',
          icon: require('../assets/icon/dodge-print.png')
        }
      ],
      orderDeskItems: [
        {
          name: 'TikTok Shop',
          type: 'Marketplace',
          setupTime: 'Moderate',
          bestFor: 'Small & middle businesses',
          linkText: 'Get Started →',
          icon: require('../assets/icon/tiktok.png')
        },
        {
          name: 'Walmart',
          type: 'Marketplace',
          setupTime: 'Moderate',
          bestFor: 'Small Businesses',
          linkText: 'Get Started →',
          icon: require('../assets/icon/walmart.png')
        },
        {
          name: 'Ebay',
          type: 'Marketplace',
          setupTime: 'Slow',
          bestFor: 'Small Businesses',
          linkText: 'Get Started →',
          icon: require('../assets/icon/ebay.png')
        },
        {
          name: 'Etsy',
          type: 'Marketplace',
          setupTime: 'Very fast',
          bestFor: 'Artists, beginners',
          linkText: 'Get Started →',
          icon: require('../assets/icon/etsy.png')
        },
        {
          name: 'Amazon',
          type: 'Marketplace',
          setupTime: 'Slow',
          bestFor: 'Small Businesses',
          linkText: 'Get Started →',
          icon: require('../assets/icon/amazon.png')
        },
        {
          name: 'Bigcommerce',
          type: 'Platform',
          setupTime: 'Fast',
          bestFor: 'Small Businesses',
          linkText: 'Get Started →',
          icon: require('../assets/icon/bigcommerce.png')
        },
        {
          name: 'Prestashop',
          type: 'Open source platform',
          setupTime: 'Moderate',
          bestFor: 'Developers, large retailers',
          linkText: 'Get Started →',
          icon: require('../assets/icon/prestashop.png')
        },
        {
          name: 'Magento',
          type: 'Open source platform',
          setupTime: 'Slow',
          bestFor: 'Developers, large retailers',
          linkText: 'Get Started →',
          icon: require('../assets/icon/magento.png')
        },
        {
          name: 'Squarespace',
          type: 'Platform',
          setupTime: 'Moderate',
          bestFor: 'Artists, beginners',
          linkText: 'Get Started →',
          icon: require('../assets/icon/squarespace.png')
        },
        {
          name: 'Webflow',
          type: 'Platform',
          setupTime: 'Moderate',
          bestFor: 'Artists, beginners',
          linkText: 'Get Started →',
          icon: require('../assets/icon/webflow.png')
        },
        {
          name: 'Ecwid',
          type: 'Platform',
          setupTime: 'Fast',
          bestFor: 'Small businesses',
          linkText: 'Get Started →',
          icon: require('../assets/icon/ecwid.png')
        },
        {
          name: 'WooCommerce',
          type: 'Open source platform',
          setupTime: 'Moderate',
          bestFor: 'Developers, large retailers',
          linkText: 'Get Started →',
          icon: require('../assets/icon/woo.png')
        },
        {
          name: 'Weebly',
          type: 'Platform',
          setupTime: 'Moderate',
          bestFor: 'Artists, beginners',
          linkText: 'Get Started →',
          icon: require('../assets/icon/weebly.png')
        },
        {
          name: 'Square',
          type: 'Platform',
          setupTime: 'Moderate',
          bestFor: 'Artists, beginners',
          linkText: 'Get Started →',
          icon: require('../assets/icon/square.png')
        },
        {
          name: 'Shift4Shop',
          type: 'Platform',
          setupTime: 'Moderate',
          bestFor: 'Artists, beginners',
          linkText: 'Get Started →',
          icon: require('../assets/icon/shift4shop.png')
        },
        {
          name: 'ShipStation',
          type: 'Platform',
          setupTime: 'Moderate',
          bestFor: 'Developers, large retailers',
          linkText: 'Get Started →',
          icon: require('../assets/icon/shipstation.png')
        },
        {
          name: 'Samcart',
          type: 'Platform',
          setupTime: 'Fast',
          bestFor: 'Small Businesses',
          linkText: 'Get Started →',
          icon: require('../assets/icon/samcart.png')
        },
        {
          name: 'Wayfair',
          type: 'Marketplace',
          setupTime: 'Slow',
          bestFor: 'Small Businesses',
          linkText: 'Get Started →',
          icon: require('../assets/icon/wayfair.png')
        },
        {
          name: 'Wish',
          type: 'Marketplace',
          setupTime: 'Moderate',
          bestFor: 'Small businesses',
          linkText: 'Get Started →',
          icon: require('../assets/icon/wish.png')
        },
        {
          name: 'Gumroad',
          type: 'Platform',
          setupTime: 'Fast',
          bestFor: 'Artists, beginners',
          linkText: 'Get Started →',
          icon: require('../assets/icon/gumroad.png')
        }
      ]
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  methods: {}
}
</script>

<style scoped lang="less">
.integrations_content {
  width: 1280px;
  margin: 0 auto 0;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  font-family: HarmonyOS Sans SC;
}

.special_banner {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(../assets/icon/special_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 449px;
  margin-top: 15px;
  position: relative;
}

.left_box {
  position: absolute;
  top: 76px;
  left: 90px;
  z-index: 1;
}

.small_title {
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  margin-bottom: 2px;
}

.left_box h1 {
  font-weight: 900;
  font-size: 56px;
  color: #FFFFFF;
  line-height: 72px;
  margin: 0 0 28px 0;
  background: linear-gradient(0deg, #27FFDE 0%, #647CFF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
}

.text {
  font-weight: 400;
  font-size: 16px;
  color: #C5FAFF;
  line-height: 1.6;
  margin-bottom: 35px;
  max-width: 600px;
}

.btn_wrap {
  display: inline-block;
}

.btn-standard {
  display: inline-block;
  width: 170px;
  height: 53px;
  background: #C5FAFF;
  border-radius: 5px;
  font-weight: bold;
  font-size: 18px;
  color: #111111;
  line-height: 53px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-standard:hover {
  background: #92f0fa;
}

.integrations-section {
  margin-top: 62px;
  width: 100%;
}

.section-title {
  font-weight: 500;
  font-size: 40px;
  color: #111111;
  margin-bottom: 28px;
  text-align: center;
}

.grid-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

/* 卡片样式 */
.integration-card {
  background: #FFFFFF;
  border-radius: 18px;
  border: 1px solid #E5E5E5;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .card-box {
    border-radius: 18px;
    padding: 25px 33px;
  }

  .card-header {
    display: flex;
    height: 52px;
    align-items: center;
    margin-bottom: 25px;
    gap: 20px;
  }

  .card-name {
    font-weight: 500;
    font-size: 20px;
    color: #111111;
    padding: 0 24px;
    height: 39px;
    line-height: 39px;
    background: #FFFFFF;
    border-radius: 19px;
  }

  .card-key {
    font-weight: bold;
    font-size: 16px;
    color: #111111;
    margin-bottom: 10px;
  }

  .card-value {
    font-weight: 400;
    font-size: 16px;
    color: #111111;
  }

  .card-link {
    height: 43px;
    font-weight: 500;
    font-size: 16px;
    color: #012169;
    margin-left: 31px;
    padding-top: 12px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: all 0.6s ease;

    .link-arrow {
      display: inline-block;
      transition: transform 0.6s ease;
    }

    &:hover .link-arrow {
      transform: translateX(6px);
    }
  }
}

.card-gray {
  background-color: #F5F3FC;
}

.card-green {
  background-color: #F5FAEF;
}

.card-blue {
  background-color: #EDFDFF;
}

.card-lightblue {
  background-color: #EFF6FF;
}

.card-pink {
  background-color: #FEF2F2;
}

.bottom-cta {
  margin-top: 97px;
  padding: 36px 0 44px 0;
  text-align: center;
  background-image: url(../assets/icon/power_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-bottom: 75px;

  .cta-subtitle {
    font-weight: 400;
    font-size: 18px;
    color: #111111;
    margin-bottom: 8px;
  }

  .cta-title {
    font-weight: bold;
    font-size: 32px;
    color: #111111;
    margin-bottom: 16px;
  }

  .cta-btn {
    display: inline-block;
    width: 189px;
    height: 50px;
    line-height: 50px;
    background: #012169;
    border-radius: 5px;
    font-weight: bold;
    font-size: 18px;
    color: #FFFFFF;
    transition: background-color 0.3s ease;

    &:hover {
      background: #3a4d78;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Integrations.vue